import React from 'react';

//the context to save the client settings
export const SettingsContext = React.createContext({
    temperatureUnit: "C"
});

